import React from "react";
import "./deptSelector.css";

const DeptSelector = ({ dept, selectedDept, setSelectedDept }) => {
  return (
    <>
      <div>
        <label className="label">
          Select Course Code:
          <select
            value={selectedDept}
            className="dept-selector-dropdown"
            placeholder="Select Course Code"
            onChange={(e) => setSelectedDept(e.target.value)}>
            <option value="All Course Codes">All Course Codes</option>
            {dept.map((item, index) => (
              <option key={index} value={item.Course_Code}>
                {item.Course_Code}
              </option>
            ))}
          </select>
        </label>
      </div>
    </>
  );
};

export default DeptSelector;
